import PartnersBanner from "../components/PartnersBanner";
import React from "react";
import ReactDOM from "react-dom";

const renderMarquee = ($) => {
	const marqueeParent = $( '#js-marquee-banner' )[0]
	const marqueeElements = $('.js-marquee-banner-partner').toArray();

	if (marqueeParent && marqueeElements) {
		ReactDOM.render(
			<PartnersBanner marqueeElements={marqueeElements} />,
			marqueeParent
		);
	}
};

export default renderMarquee;
